export const environment = {
  production: true,
  apiHost: 'http://api-alava.gesdencolegiosone.es/api/'
};
